/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_SendingInputs */

const th_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังส่ง…`)
};

const en_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const ja_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信中…`)
};

const zh_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在发送…`)
};

const es_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const pt_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const id_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengirim…`)
};

const fr_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi…`)
};

const tl_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ipinapadala…`)
};

const vi_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang gửi…`)
};

const ko_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보내는 중…`)
};

const de_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gesendet…`)
};

const ru_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправляем…`)
};

const tr_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönderiliyor…`)
};

const it_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio…`)
};

const pl_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysyłanie…`)
};

const uk_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Надсилаємо…`)
};

const hi_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भेजा जा रहा है…`)
};

const ar_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ الإرسال…`)
};

const ms_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang menghantar…`)
};

const bn_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পাঠানো হচ্ছে…`)
};

const zh_tw2_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄送中…`)
};

const zh_hk2_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄送中…`)
};

const ur_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بھیجا جا رہا ہے…`)
};

const fa_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال فرستادن…`)
};

const sw_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inatumwa…`)
};

const nl_invite_sending = /** @type {(inputs: Invite_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met versturen…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Invite_SendingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const invite_sending = /** @type {((inputs?: Invite_SendingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_SendingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_invite_sending(inputs)
	if (locale === "ja") return ja_invite_sending(inputs)
	if (locale === "zh") return zh_invite_sending(inputs)
	if (locale === "es") return es_invite_sending(inputs)
	if (locale === "pt") return pt_invite_sending(inputs)
	if (locale === "id") return id_invite_sending(inputs)
	if (locale === "fr") return fr_invite_sending(inputs)
	if (locale === "tl") return tl_invite_sending(inputs)
	if (locale === "vi") return vi_invite_sending(inputs)
	if (locale === "ko") return ko_invite_sending(inputs)
	if (locale === "de") return de_invite_sending(inputs)
	if (locale === "ru") return ru_invite_sending(inputs)
	if (locale === "tr") return tr_invite_sending(inputs)
	if (locale === "it") return it_invite_sending(inputs)
	if (locale === "pl") return pl_invite_sending(inputs)
	if (locale === "uk") return uk_invite_sending(inputs)
	if (locale === "hi") return hi_invite_sending(inputs)
	if (locale === "ar") return ar_invite_sending(inputs)
	if (locale === "ms") return ms_invite_sending(inputs)
	if (locale === "bn") return bn_invite_sending(inputs)
	if (locale === "zh-TW") return zh_tw2_invite_sending(inputs)
	if (locale === "zh-HK") return zh_hk2_invite_sending(inputs)
	if (locale === "ur") return ur_invite_sending(inputs)
	if (locale === "fa") return fa_invite_sending(inputs)
	if (locale === "sw") return sw_invite_sending(inputs)
	if (locale === "nl") return nl_invite_sending(inputs)
	return en_invite_sending(inputs)
});